export default class Navigation {
    constructor(element) {
        this.element = element
        this.opened = false
        this.openedMobile = false

        /* Mobile Menu Container */
        this.mobileMenuWrapper = element.querySelector('.navigation__wrapper');

        /* Burger Menu */
        this.mobileMenuToggle = element.querySelector('.navigation__toggle');
        if (this.mobileMenuToggle) {
            this.mobileMenuToggle.addEventListener('click', () => {
                this.toggleMobileMenu()
            })
        }


        let listFirst = element.querySelector('.navigation__first')
        if (listFirst !== null) {
            this.itemsFirst = listFirst.querySelectorAll('.navigation__first__item')
            if (this.itemsFirst.length === 0) return;
            this.itemsFirst.forEach((itemFirst) => {
                this.initMenuItem(itemFirst)
            })
        }

        /* Assign close function to close buttons */
        let closeButtons = element.querySelectorAll('.navigation__second__close');
        if (closeButtons !== null) {
            closeButtons.forEach((button) => {
                button.addEventListener('click', () => {
                    this.closeAllSecondMenus()
                })
            })
        }

        // Close the navigation when clicking anywhere else
        let contents = document.querySelectorAll('body > *:not(.navigationAnchor)')
        for (let i = 0; i < contents.length; i++) {
            contents[i].addEventListener('click', () => this.closeAllSecondMenus())
        }

        document.addEventListener('scroll', () => {
            this.checkMenuState()
        })
        window.addEventListener('DOMContentLoaded', () => {
            setTimeout(() => {
                this.checkMenuState()
            }, 250);

        })
    }

    initMenuItem(item) {
        let itemLabel = item.querySelector('span.label')
        if (itemLabel !== null) {
            itemLabel.addEventListener('click', (e) => {
                /* Make sure that only the event bind on the spans triggers the menu */
                if (e.target === itemLabel) {
                    if (!itemLabel.classList.contains('active')) {
                        this.openSecondMenu(item)
                        return
                    }
                    if (itemLabel.classList.contains('active')) {
                        this.closeAllSecondMenus()
                    }
                }
            })
        }
    }

    getScrollState() {
        if (window.pageYOffset === 0) {
            return false
        }
        if (window.pageYOffset !== 0) {
            return true
        }
    }

    attachMenu() {
        if (this.element.classList.contains('fixed') === false) {
            this.element.classList.add('fixed')
        }
    }

    detachMenu() {
        if (this.element.classList.contains('fixed') === true) {
            this.element.classList.remove('fixed')
        }
    }

    setActiveState(element) {
        let span = element.querySelector('span.label')
        if (span !== null && !span.classList.contains('active')) {
            span.classList.add('active')
        }
    }

    removeActiveState(element) {
        let span = element.querySelector('span.label')
        if (span !== null && span.classList.contains('active')) {
            span.classList.remove('active')
        }
    }

    checkMenuState() {
        this.getScrollState() ? this.attachMenu() : this.detachMenu()
    }

    openSecondMenu(element) {
        this.closeAllSecondMenus()
        /* Set new active state */
        let navigationSecond = element.querySelector('.navigation__second')
        navigationSecond.classList.add('active')
        this.setActiveState(element)
        this.opened = true
        this.attachMenu()
    }

    closeAllSecondMenus() {
        if (!this.itemsFirst) return;

        this.itemsFirst.forEach((itemFirst) => {
            this.removeActiveState(itemFirst)
            let secondLevel = itemFirst.querySelector('.navigation__second')
            if (secondLevel.classList.contains('active')) {
                secondLevel.classList.remove('active')
            }
        })
        this.opened = false
        this.checkMenuState()
    }

    disableBodyScroll() {
        document.body.classList.add('no-scroll');
    }

    enableBodyScroll() {
        document.body.classList.remove('no-scroll');
    }

    toggleMobileMenu() {
        if (this.mobileMenuWrapper !== null) {
            if (this.mobileMenuWrapper.classList.contains('active')) {
                this.mobileMenuWrapper.classList.remove('active')
                this.enableBodyScroll()
                return
            }

            this.mobileMenuWrapper.classList.add('active')
            this.disableBodyScroll()
            this.attachMenu()
        }
    }

}
